import {exists, t} from 'i18next';

export default function translateOrFallback(
  key: string,
  fallback: string,
): string {
  return exists(key) ? t(key) : fallback;
}
